import { render, staticRenderFns } from "./screen-card-ephemeris.vue?vue&type=template&id=6042b096&scoped=true"
import script from "./screen-card-ephemeris.vue?vue&type=script&lang=ts"
export * from "./screen-card-ephemeris.vue?vue&type=script&lang=ts"
import style0 from "./screen-card-ephemeris.vue?vue&type=style&index=0&id=6042b096&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042b096",
  null
  
)

export default component.exports